module.exports = __webpack_public_path__ + "static/media/homeImage@3x.e7a593a3.png";